import React, { createContext } from "react";
import { PatientProfileRoutePath } from "../navigation/route-config";


export interface PatientProfilePageContextProps {
  route: PatientProfileRoutePath | undefined
  goTo: (route: PatientProfileRoutePath) => void
  isLoading: boolean
}

export const PatientProfilePageContext = createContext<PatientProfilePageContextProps>(null!)